import { memo } from 'react';

import SkeletonRound from '@/assets/images/skeleton-round.svg?react';
import { Diamond } from '@/entities/Diamond';

import styles from './DiamondRow.module.scss';

interface DiamondRowProps {
  diamond: Diamond;
}

function DiamondRow(props: DiamondRowProps) {
  const { diamond } = props;

  return (
    <div className={styles.root}>
      <div className={styles.image}>
        {diamond.isValid && <img src={diamond.lightningPreview('Office')?.url} alt="" />}

        {!diamond.isValid && <SkeletonRound width="80%" height="80%" />}
      </div>

      <div className={styles.description}>
        <div className={styles.sku}>{diamond.sku}</div>

        <div className={styles.title}>{diamond.shortView ?? diamond.error}</div>

        {(diamond.hasIntegralV2 || diamond.performance?.integral) && (
          <div className={styles.opticalPerformance}>
            <span className={styles.opticalPerformanceLabel}>{diamond.hasIntegralV2 ? 'Performance v2 (Beta): ' : 'Performance: '}</span>

            <span>&nbsp;{diamond.hasIntegralV2 ? diamond.shapeIntegralV2Hr : diamond.shapeIntegralHr}</span>
          </div>
        )}

        {diamond.labGrown && <div className={styles.labgrown}>Lab-Grown</div>}
      </div>
    </div>
  );
}

export default memo(DiamondRow);
